import React, { useEffect } from 'react';
import { motion } from 'motion/react';

interface BrandIntroProps {
  onComplete: () => void;
}

export default function BrandIntro({ onComplete }: BrandIntroProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 2700); // 1.2s animation + 1.5s hold
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-[1000] bg-white flex flex-col items-center justify-center p-8"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          duration: 1.2,
          ease: "easeOut"
        }}
        className="flex flex-col items-center"
      >
        {/* NumQ Logo */}
        <div className="w-64 h-64 relative flex items-center justify-center">
          <img 
            src="/numq logo.png" 
            alt="numQ Logo" 
            className="w-full h-auto object-contain"
          />
        </div>

        {/* PSB Ideas Studio Name */}
        <div className="mt-12">
          <div className="font-space-grotesk text-4xl tracking-tight text-slate-900">
            <span className="font-bold">PSB</span> <span className="font-medium">Ideas</span>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
